import { axios } from "../connection/ConnectionHandler";
import { API } from "../constants/api";
import { keyBy } from "lodash";
import {
  ADD_NEW_COMPONENTTYPE,
  DELETE_COMPONENTTYPE,
  COMPONENTTYPE_FORM_TOOGLE_LOADING,
  SET_COMPONENTTYPE_LIST,
  SHOW_NOTIFICATION,
  UPDATE_COMPONENTTYPE,
} from "../constants";
import { formatComponentTypes } from "./settingsActionsUtils";

/* COMPONENTTYPE LIST */
export const fetchComponentTypes = () => {
  return async (dispatch) => {
    const response = await axios
      .get(API.componentTypes.list)
      .then((response) => {
        const componentTypes = formatComponentTypes(response.data);
        dispatch({
          type: SET_COMPONENTTYPE_LIST,
          payload: keyBy(componentTypes, "_id"),
        });
        return response.status;
      })
      .catch((err) => err);
    return response;
  };
};

// COMPONENTTYPES
export const createComponentType = (newComponentType) => {
  return async (dispatch) => {
    dispatch({ type: COMPONENTTYPE_FORM_TOOGLE_LOADING });
    const response = await axios
      .post(API.componentTypes.create, newComponentType)
      .then((response) => {
        const componentType = formatComponentTypes(response.data);
        dispatch({ type: ADD_NEW_COMPONENTTYPE, payload: componentType });
        dispatch({ type: COMPONENTTYPE_FORM_TOOGLE_LOADING });
        dispatch({
          type: SHOW_NOTIFICATION,
          payload: {
            show: true,
            status: "success",
            message: "Tipo de componente creado con éxito.",
          },
        });
        return response?.status;
      })
      .catch((err) => {
        dispatch({ type: COMPONENTTYPE_FORM_TOOGLE_LOADING });
        return err;
      });
    return response;
  };
};

export const updateComponentType = (updatedComponentType) => {
  return async (dispatch) => {
    dispatch({ type: COMPONENTTYPE_FORM_TOOGLE_LOADING });
    const response = await axios
      .put(
        `${API.componentTypes.edit}${updatedComponentType?._id}`,
        updatedComponentType
      )
      .then((response) => {
        const componentType = formatComponentTypes(response.data);
        dispatch({ type: UPDATE_COMPONENTTYPE, payload: componentType });
        dispatch({ type: COMPONENTTYPE_FORM_TOOGLE_LOADING });
        dispatch({
          type: SHOW_NOTIFICATION,
          payload: {
            show: true,
            status: "info",
            message: "Tipo de componente actualizado.",
          },
        });
        return response?.status;
      })
      .catch((err) => {
        dispatch({ type: COMPONENTTYPE_FORM_TOOGLE_LOADING });
        return err;
      });
    return response;
  };
};

export const deleteComponentTypes = (Ids) => {
  return async (dispatch) => {
    dispatch({ type: COMPONENTTYPE_FORM_TOOGLE_LOADING });
    const response = await axios
      .delete(`${API.componentTypes.delete}`, { data: Ids })
      .then((response) => {
        dispatch({ type: DELETE_COMPONENTTYPE, payload: Ids });
        dispatch({ type: COMPONENTTYPE_FORM_TOOGLE_LOADING });
        dispatch({
          type: SHOW_NOTIFICATION,
          payload: {
            show: true,
            status: "info",
            message: "Tipo de componente eliminado.",
          },
        });
        return response?.status;
      })
      .catch((err) => {
        dispatch({ type: COMPONENTTYPE_FORM_TOOGLE_LOADING });
        return err;
      });
    return response;
  };
};
